var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInquiry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.12568 17.1153C6.89983 17.1153 6.69422 17.0209 6.50886 16.8321C6.32349 16.6433 6.23081 16.4339 6.23081 16.2038V14.4871H18.3622L18.6795 14.8045V5.99998H20.4231C20.6489 5.99998 20.8528 6.09437 21.0348 6.28315C21.2167 6.47193 21.3077 6.6848 21.3077 6.92175V18.7601C21.3077 19.1111 21.1475 19.3526 20.8272 19.4846C20.5069 19.6166 20.2237 19.5595 19.9776 19.3133L17.7795 17.1153H7.12568ZM6.23081 12.7307L4.02251 14.939C3.77636 15.1852 3.49313 15.2423 3.17283 15.1103C2.85253 14.9783 2.69238 14.7368 2.69238 14.3858V3.41155C2.69238 3.18142 2.78336 2.97196 2.96531 2.78318C3.14724 2.59439 3.35114 2.5 3.57701 2.5H16.0282C16.2609 2.5 16.4683 2.59268 16.6502 2.77805C16.8321 2.96342 16.9231 3.17458 16.9231 3.41155V11.8192C16.9231 12.0493 16.8321 12.2588 16.6502 12.4475C16.4683 12.6363 16.2609 12.7307 16.0282 12.7307H6.23081ZM15.6667 11.4743V3.75637H3.94876V12.1667L4.64113 11.4743H15.6667Z",
    fill: "#1C2227"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInquiry);
export default __webpack_public_path__ + "static/media/inquiry.292922c5df98920302c3458c65b07a07.svg";
export { ForwardRef as ReactComponent };